/**
 * Get the post current price.
 */
export default function (postId, priceCurrent) {
    return {
        postId: postId,
        price: priceCurrent,
        getPrice: function () {
            return this.price + ' €';
        },
        mounted: function () {
            const self = this;

            /**
             * Update the post price.
             *
             * @param {Object} data
             */
            function updatePrice(data) {
                if (data.id != self.postId) {
                    return;
                }

                self.price = data.price_current_formatted;
            }

            const channel = window.Echo.connector.channels['posts'];

            if (channel) {
                channel.listen('Posts.PostUpdated', (data) => updatePrice(data));
                return;
            }

            window.Echo.channel('posts').listen('Posts.PostUpdated', (data) => updatePrice(data));
        },
    };
}
